module.exports = __webpack_public_path__ + "static/assets/5844a8433c328a12f49acd186451e1be.gif";